import { Card, Col, Row, Table } from "antd";
import React from "react";
import logoImg from "../../images/logo.jpg";
import { ColumnProps } from "antd/es/table";
import "./style.css";

const Index = () => {
  const dataSource = [
    {
      key: "1",
      a1: "ZJ001",
      a2: "互联网银行",
      a3: "微众银行",
      a4: "9144030031977063XH",
      a5: "2019-08-01",
      a6: "订货贷",
    },
    {
      key: "2",
      a1: "ZJ002",
      a2: "商业银行",
      a3: "华润银行",
      a4: "9144040019260094XE",
      a5: "2019-01-01",
      a6: "",
    },
  ];

  const columns: ColumnProps<any>[] = [
    {
      title: "资金方编号",
      dataIndex: "a1",
      key: "a1",
      align: "center",
    },
    {
      title: "资金方类型",
      dataIndex: "a2",
      key: "a2",
      align: "center",
    },
    {
      title: "资金方名称",
      dataIndex: "a3",
      key: "a3",
      align: "center",
    },
    {
      title: "社会统一信用代码",
      dataIndex: "a4",
      key: "a4",
      align: "center",
    },
    {
      title: "合作日期",
      dataIndex: "a5",
      key: "a5",
      align: "center",
    },
    {
      title: "金融产品",
      dataIndex: "a6",
      key: "a6",
      align: "center",
    },
    {
      title: "产品利率",
      dataIndex: "a7",
      key: "a7",
      align: "center",
    },
    {
      title: "期限（天）",
      dataIndex: "a8",
      key: "a8",
      align: "center",
    },
    {
      title: "最高额度",
      dataIndex: "a9",
      key: "a9",
      align: "center",
    },
    {
      title: "还款方式",
      dataIndex: "a10",
      key: "a10",
      align: "center",
    },
  ];

  return (
    <div className="homes">
      <Card title="资金列表" style={{ marginTop: "20px" }} className="messages">
        <Row gutter={24} className="rows">
          <Col span={24} className="cols">
            <Card>
              {/* <h2 style={{ textAlign: "center" }}>订单贷资产</h2> */}
              <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
              />
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Index;
